export const Subscription = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Card body - outline only (matches the stroke-based icons like Bills) */}
      <rect
        x="2.75"
        y="4.75"
        width="18.5"
        height="14.5"
        rx="2.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {/* Magnetic stripe */}
      <path
        d="M2.75 9.5H21.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Card number blocks */}
      <path
        d="M6 15.25H9.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12.5 15.25H14.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Recurring marker */}
      <circle cx="17.75" cy="15.25" r="1" fill="currentColor" />
    </svg>
  );
};
